/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CommentType {
  Default = 0,
  CaseManagementNote = 1,
  FinancialsNote = 2,
}
